import { getGridStringOperators, GridFilterInputValueProps, GridFilterOperator } from '@mui/x-data-grid-pro'
import { Option } from 'src/shared/form/control'
import { AutoCompleteFilterInput } from 'src/shared/form/grid/filter/AutoCompleteFilterInput'
import { normalizeString } from 'src/shared/utils/StringNormalizationUtils'

export const commonlyUsedStringOperators: string[] = [
  'contains',
  'doesNotContain',
  'equals',
  'doesNotEqual',
  'startsWith',
  'endsWith',
]

const applyNormalizationToOperators = (operator: GridFilterOperator) => {
  const getApplyFilterFn: GridFilterOperator['getApplyFilterFn'] = (filterItem, column) => {
    const innerFilterFn = operator.getApplyFilterFn(
      {
        ...filterItem,
        value: normalizeString(filterItem.value),
      },
      column,
    )

    if (!innerFilterFn) {
      return innerFilterFn
    }

    return (value, row, column, apiRef) => {
      return innerFilterFn(normalizeString(value), row, column, apiRef)
    }
  }

  return {
    ...operator,
    getApplyFilterFn,
  }
}

export const getGridStringsOperatorsIgnoreAccents = (): GridFilterOperator<any, number | string | null, any>[] => {
  return getGridStringOperators().map((item) => applyNormalizationToOperators(item))
}

export const autoCompleteContainsArrayFilterOperator = (
  options: Option[],
  label: string,
  placeholder: string,
  comparatorLabel: string,
) => {
  return [
    {
      label: comparatorLabel,
      value: 'containsArray',
      getApplyFilterFn: (filterItem: any) => {
        if (!filterItem.value) {
          return null
        }

        return (value: any) => {
          if (!Array.isArray(value)) {
            return false
          }
          return value.includes(filterItem.value)
        }
      },
      InputComponent: (gridFilterProps: GridFilterInputValueProps) => (
        <AutoCompleteFilterInput {...gridFilterProps} options={options} label={label} placeholder={placeholder} />
      ),
    },
  ]
}
